/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/

import React from 'react';
import { createStyles, makeStyles } from "@material-ui/styles";
import { FormControl, InputLabel, Select, MenuItem, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        padding: theme.spacing(1),
        display: "flex",
        borderRadius: theme.shape.borderRadius,
        color: "inherit",
        alignItems: "center",
        justifyContent: "space-between"
    },
    formControl: {
        minWidth: 50,
    },
    inputLabel: {
        fontSize: 13,
        transform: 'translate(14px, 10px) scale(1)',
    },
    select: {
        fontSize: 13,
        padding: '6px 10px',
        height: 24,
        backgroundColor: 'white',
        '&:focus': { backgroundColor: 'white'},
    },
    menuItem: {
        fontSize: 13,
        paddingTop: 6,
        paddingBottom: 6,
    },
  })
);

interface DropdownProps {
  className?: string;
  label: string;
  selectedValue: string;
  options: { value: string; label: string }[];
  onDropdownOptionChange?: (value: string) => void;
}

const Dropdown = (props: DropdownProps) => {
    const classes = useStyles(props);

    const handleChange = (event: any) => {
        if (props.onDropdownOptionChange) {
            props.onDropdownOptionChange(event.target.value);
        }
    };

    return (
        <div className={classes.root.concat(props.className ? ` ${props.className}` : "")}>
            <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel className={classes.inputLabel}>{props.label}</InputLabel>
                <Select
                    classes={{root: classes.select}}
                    labelId={`${props.label}-label`}
                    value={props.selectedValue}
                    label={props.label}
                    onChange={handleChange}
                >
                    {props.options.map(option => (
                        <MenuItem key={option.value} value={option.value} className={classes.menuItem}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default Dropdown;
